module.exports = __webpack_public_path__ + "img/telefone.9b34624e.svg";